(function paycheckTestAddControllerDefinition() {
    'use strict';

    angular.module('PaycheckTest')
        .controller('PaycheckTestAddController', [
            '$filter', '$state', '$scope', 'errorsExtend', 'processService', 'configViewService', 'fileService', 'authExtend', 'messages', 'fileDownloader',
            function paycheckTestAddController($filter, $state, $scope, errors, processService, configViewService, fileService, auth, messages, fileDownloader) {
                $scope.preview = {
                    closed: true,
                    closedCert: true,
                    loading: false,
                    content: null,
                    index: null,
                    item: null,
                    invalid: false
                };


                $scope.fileReaderSupported = window.FileReader !== undefined && window.FileReader !== null && (window.FileAPI === null || window.FileAPI === undefined || window.FileAPI.html5 !== false);
                $scope.showImageLoad = true;

                $scope.addFile = function () {
                    $scope.aux.filesTemp.forEach(function (file) {
                        if (file && file.size) {
                            file.fsize = fileService.FormatfileSize(file.size);
                            if (file.name.indexOf(".pdf") > 0) {
                                var index = $scope.getIndexFile(file);
                                if (~index) {
                                    $scope.aux.files[index] = file;
                                } else {
                                    if ($scope.aux.files.length > 0) {
                                        return errors.showError('MultiplePaycheckTestValidation') || false;
                                    }
                                    $scope.aux.files.push(file);
                                }
                            }
                        }
                    });

                    $scope.aux.filesTemp = [];
                };

                $scope.addCertificateFile = function () {
                    $scope.aux.certificateFilesTemp.forEach(function (file) {
                        if (file && file.size) {
                            file.fsize = fileService.FormatfileSize(file.size);
                            if (file.name.indexOf(".pfx") > 0) {
                                var index = $scope.getIndexFileCertificate(file);
                                if (~index) {
                                    $scope.aux.certificateFiles[index] = file;
                                } else {
                                    if ($scope.aux.certificateFiles.length > 0) {
                                        return errors.showError('MultiplePaycheckTestValidation') || false;
                                    }
                                    $scope.aux.certificateFiles.push(file);
                                }
                            }
                        }
                    });

                    $scope.aux.certificateFilesTemp = [];
                };

                $scope.getIndexFile = function (fileNew) {
                    for (var i in $scope.aux.files) {
                        if ($scope.aux.files.hasOwnProperty(i)) {
                            var fileOld = $scope.aux.files[i];

                            if (fileOld.name === fileNew.name) {
                                return i;
                            }
                        }
                    };

                    return -1;
                };

                $scope.getIndexFileCertificate = function (fileNew) {
                    for (var i in $scope.aux.certificateFiles) {
                        if ($scope.aux.certificateFiles.hasOwnProperty(i)) {
                            var fileOld = $scope.aux.certificateFiles[i];

                            if (fileOld.name === fileNew.name) {
                                return i;
                            }
                        }
                    };

                    return -1;
                };

                $scope.onFileSelect = function onFileSelect(files) {
                    if (files && files.length && files[0].type.indexOf('image') > -1) {

                        if ($scope.fileUploadInfo.promise !== null) {
                            $scope.fileUploadInfo.promise.abort();
                            $scope.fileUploadInfo.promise = null;
                        }

                        $scope.fileUploadInfo.progress = -1;

                        // me interesa solo un archivo
                        $scope.fileUploadInfo.selectedFile = files[0];

                        if ($scope.fileReaderSupported) {

                            var fileReader = new FileReader();

                            fileReader.readAsDataURL(files[0]);

                            fileReader.onload = function (e) {
                                $scope.$apply(function () {
                                    $scope.fileUploadInfo.loadedFile = e.target.result;
                                });
                            };
                        }
                    }
                };

                $scope.resetFileUpload = function resetFileUpload() {
                    $scope.fileUploadInfo = $scope.fileUploadInfo = {
                        loadedFile: null,
                        selectedFile: null,
                        promise: null,
                        progress: -1
                    };
                };

                $scope.removeImage = function () {
                    $scope.resetFileUpload();
                };

                $scope.cancel = function () {
                    $state.go('paycheck-rrhh-find');
                };

                $scope.removeFile = function (file) {
                    var index = $scope.getIndexFile(file);

                    if (~index) {
                        if ($scope.preview.index == index) {
                            $scope.hidePreview();
                        }
                        $scope.aux.files.splice(index, 1);
                    }
                };

                $scope.removeCertificateFile = function (file) {
                    var index = $scope.getIndexFileCertificate(file);

                    if (~index) {
                        if ($scope.preview.index == index) {
                            $scope.hidePreview();
                        }
                        $scope.aux.certificateFiles.splice(index, 1);
                    }
                };

                $scope.previewFile = function (item, index) {
                    $scope.preview.content = null;
                    $scope.preview.loading = true;
                    $scope.preview.closed = false;
                    $scope.preview.invalid = false;

                    fileService.preview($scope.aux.files[index], true).then(function (result) {
                        $scope.preview.content = result;
                        $scope.preview.item = item;
                        $scope.preview.index = index;
                        $scope.preview.loading = false;
                    }, function (error) {
                        if (error.data && error.data.modelState && error.data.modelState.no_converter) {
                            $scope.preview.loading = false;
                            $scope.preview.invalid = true;
                            $scope.preview.item = item;
                            $scope.preview.index = index;
                        }
                        else {
                            errors.showError(error);
                            $scope.hidePreview();
                        }
                    });
                };

                $scope.hidePreview = function () {
                    $scope.preview = {
                        closed: true,
                        closedCert: true,
                        loading: false,
                        content: null,
                        index: null,
                        invalid: false,
                        item: null
                    };
                };

                $scope.nextPreview = function () {
                    if ($scope.preview.index + 1 < $scope.aux.files.length) {
                        $scope.preview.index++;
                        $scope.previewFile($scope.aux.files[$scope.preview.index], $scope.preview.index);
                    }
                };

                $scope.prevPreview = function () {
                    if ($scope.preview.index) {
                        $scope.preview.index--;
                        $scope.previewFile($scope.aux.files[$scope.preview.index], $scope.preview.index);
                    }
                };

                $scope.save = function () {

                    $scope.testResult = undefined;

                    if (!$scope.paycheckRRHHAdd.$valid) {
                        $scope.paycheckRRHHAdd.$setSubmitted();
                        return errors.showError('VerifyFormData') || false;
                    }

                    if ($scope.aux.files.length <= 0) {
                        return errors.showError('VerifyFormFile') || false;
                    }

                    if ($scope.aux.files.length > 1) {
                        return errors.showError('MultiplePaycheckTestValidation') || false;
                    }

                    if (!$scope.processTypeValue) {
                        return errors.showError('PaycheckTypeSelection') || false;
                    }

                    if ($scope.fileUploadInfo.selectedFile != null && $scope.fileUploadInfo.selectedFile) {
                        if (!$scope.aux.certificateFiles || $scope.aux.certificateFiles.length <= 0) {
                            return errors.showError('PaycheckHoloSign') || false;
                        }

                        if ($scope.aux.certificateFiles && $scope.aux.certificateFiles.length > 0 && $scope.aux.certificateKey == '') {
                            return errors.showError('PaycheckHoloCertificateKey') || false;
                        }
                    }

                    $scope.aux.allFiles = []
                    $scope.aux.allFiles.push($scope.aux.files[0]);
                    if ($scope.fileUploadInfo.selectedFile) {
                        $scope.aux.allFiles.push($scope.fileUploadInfo.selectedFile)
                    }
                    else {
                        if (($scope.aux.certificateFiles && $scope.aux.certificateFiles.length > 0) || $scope.aux.certificateKey != '') {
                            return errors.showError('PaycheckSelectHoloSign') || false;
                        }
                    }

                    if ($scope.aux.certificateFiles.length > 0) {
                        $scope.aux.allFiles.push($scope.aux.certificateFiles[0])
                    }

                    var paycheck = {};
                    paycheck.name = $scope.aux.files[0].name;
                    paycheck.processTypeId = 3;
                    paycheck.selectedProcessType = $scope.processTypeValue;
                    paycheck.metadataValues = [{ systemName: "_trec", value: $scope.processTypeValue }];
                    paycheck.workFlowId = 2;
                    paycheck.stateId = 100;
                    paycheck.organizationalUnitId = $scope.organizationalUnit.id;
                    paycheck.certificateKey = $scope.aux.certificateKey;

                    //return processService.testPaycheck(paycheck, $scope.aux.files[0]).then(function (result) {
                    return processService.testPaycheck(paycheck, $scope.aux.allFiles).then(function (result) {
                        $scope.testResult = {
                            sourceConfig: result.data.sourceConfig,
                            profileNumber: result.data.profileId,
                            profileCoordinateUp: result.data.profileCoordinates.arriba,
                            profileCoordinateBottom: result.data.profileCoordinates.abajo,
                            profileCoordinateLeft: result.data.profileCoordinates.izquierda,
                            profileCoordinateRight: result.data.profileCoordinates.derecha,
                            profileCoordinateDesde: result.data.profileCoordinates.desde,
                            profileCoordinateLargo: result.data.profileCoordinates.largo,
                            employeerSignCoordinateUp: result.data.employeerCoordinates.top,
                            employeerSignCoordinateBottom: result.data.employeerCoordinates.bottom,
                            employeerSignCoordinateLeft: result.data.employeerCoordinates.left,
                            employeerSignCoordinateRight: result.data.employeerCoordinates.right,
                            employeeSignCoordinateUp: result.data.employeeCoordinates.top,
                            employeeSignCoordinateBottom: result.data.employeeCoordinates.bottom,
                            employeeSignCoordinateLeft: result.data.employeeCoordinates.left,
                            employeeSignCoordinateRight: result.data.employeeCoordinates.right,
                            legendCoordinateUp: result.data.legendCoordinates.top,
                            legendCoordinateBottom: result.data.legendCoordinates.bottom,
                            legendCoordinateLeft: result.data.legendCoordinates.left,
                            legendCoordinateRight: result.data.legendCoordinates.right,
                            legendCoordinateDescription: result.data.legendCoordinates.description
                        };

                        fileDownloader.saveAs(result.data.signedPdf, 'PaycheckTest.pdf');

                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.load = function () {
                    $scope.aux = {
                        files: [],
                        filesTemp: [],
                        certificateFiles: [],
                        certificateFilesTemp: [],
                        metadataReplicate: [],
                        multiplePaycheck: false,
                        payCheckTestResult: undefined,
                        certificateKey: ''
                    };

                    $scope.loadViewOptions();
                    $scope.resetFileUpload();

                };

                $scope.loadViewOptions = function () {
                    if (!$scope.processTypes || $scope.processTypes.length < 1) {
                        configViewService.getById("CPPPaycheckRRHH").then(function (result) {
                            if (result.processTypes && result.processTypes.length > 0) {
                                $scope.processTypes = [];
                                angular.forEach(result.processTypes, function (item) {
                                    $scope.loadMetadata(item);
                                });

                                var found = $filter('filter')($scope.processTypes, { preSelected: true }, true);
                                $scope.processType = found[0] || $scope.processTypes[0];
                            }
                        }, function (error) {
                            errors.showError(error);
                        });
                    }
                };

                $scope.loadMetadata = function (item) {
                    var processType = {
                        name: item.name,
                        id: item.processTypeId,
                        preSelected: item.preSelected,
                        metadatas: []
                    };

                    item.metadatas.forEach(function (metadata) {
                        if (metadata.systemName === "_trec" && metadata.createCriteria) {
                            var data = {
                                idObject: item.name.replace(/ /g, '_') + metadata.systemName,
                                metadataId: metadata.metadataId,
                                metadataValueFrom: undefined,
                                metadataValueTo: undefined,
                                metadataSearchTypeFrom: undefined,
                                metadataSearchTypeTo: undefined,
                                metadataType: metadata.metadataType != null ? metadata.metadataType.toLowerCase() : undefined,
                                metadataSystemName: metadata.systemName,
                                metadataLabel: metadata.createCriteria.name,
                                metadataReadOnly: !metadata.createCriteria.isEditable,
                                metadataEnabled: true,
                                metadataOptions: metadata.metadataOptionValues,
                                maskOptions: metadata.metadataMaskOption,
                                order: metadata.createCriteria.order
                            }

                            processType.metadatas.push(data);
                        }
                    });

                    processType.metadatas.sort(function (a, b) {
                        return a.order - b.order;
                    });

                    $scope.processTypes.push(processType);
                };

                $scope.selectProcessType = function (processType) {
                    $scope.processType = processType;
                };

                $scope.load();
                $scope.control = function (value, idOu) {
                    if (value.metadataSystemName === '_trec') {
                        $scope.processTypeValue = value.metadataValue;
                    }
                };

                $scope.$watch('preview.closed', function () {
                    if ($scope.preview.closed === false) {
                        $scope.previewFile($scope.aux.files[0], 0);
                    }
                });

            }
        ]);
})();
